import { FormControl, FormGroup, Validators } from "@angular/forms";
import { PRIORITY } from "./string_literal";

export interface editClaim {
  id: string,
  assignee: string,
  priority: number,
}

export interface uploadedFile {
  name: string;
  size: number;
  id?: string;
  status: string;
  showUploaded: boolean;
  subscription: any;
}

export class editClaimForm {
  defaultForm = new FormGroup({
    id: new FormControl('', [Validators.required]),
    title: new FormControl('', [Validators.required]),
    contactPersonName: new FormControl(''),
    contactPersonEmail: new FormControl(''),
    contactPersonPhone: new FormControl(''),
    contactPersonAddress: new FormControl(''),
    equipmentId: new FormControl(''),
    vesselId: new FormControl(''),
    equipmentCurrentStatus: new FormControl(''),
    assignee: new FormControl(''),
    priority: new FormControl(PRIORITY.LOW),
    mark: new FormControl(null),
    status: new FormControl(0),
    extraDetails: new FormControl(''),
    incidentDate: new FormControl(''),
    incidentLeadup: new FormControl(''),
    incidentPlace: new FormControl(''),
    responseMeasures: new FormControl(''),
    responseRequestDetails: new FormControl(''),
    isRead: new FormControl(1),
    nextPort: new FormControl(''),
    expectedPortCall: new FormControl(''),
    isConfidential: new FormControl(0),
    attachmentIds: new FormControl<string[]>([]),
    emailThreadIds: new FormControl<string[]>([]),
    tags: new FormControl<string[]>([]),
    csNumberSuffix: new FormControl(''),
    recordType: new FormControl('claim')
  })
}

export class postClaimForm {
  defaultForm = new FormGroup({
    assignee: new FormControl<string | null>(null),
    attachmentIds: new FormControl<string[]>([]),
    priority: new FormControl(PRIORITY.LOW),
    mark: new FormControl<number | null>(null),
    contactPersonName: new FormControl<string | null>(null),
    contactPersonEmail: new FormControl<string | null>(null),
    contactPersonPhone: new FormControl<string | null>(null),
    contactPersonAddress: new FormControl<string | null>(null),
    equipmentId: new FormControl<string | null>(null),
    vesselId: new FormControl<string | null>(null),
    equipmentCurrentStatus: new FormControl('', [Validators.required]),
    expectedPortCall: new FormControl<string | null>(null),
    extraDetails: new FormControl<string | null>(null),
    incidentDate: new FormControl<string | null>(null),
    incidentLeadup: new FormControl<string | null>(null),
    incidentPlace: new FormControl<string | null>(null),
    nextPort: new FormControl<string | null>(null),
    responseMeasures: new FormControl<string | null>(null),
    responseRequestDetails: new FormControl<string | null>(null),
    title: new FormControl('', [Validators.required]),
    isRead: new FormControl(0),
    isConfidential: new FormControl(0),
    tags: new FormControl<string[]>([]),
    csNumberSuffix: new FormControl(''),
    recordType: new FormControl('claim')
  })
}

export class postInquiryForm {
  defaultForm = new FormGroup({
    assignee: new FormControl<string | null>(null),
    attachmentIds: new FormControl<string[]>([]),
    priority: new FormControl(PRIORITY.LOW),
    mark: new FormControl<number | null>(null),
    contactPersonName: new FormControl<string | null>(null),
    contactPersonEmail: new FormControl<string | null>(null),
    contactPersonPhone: new FormControl<string | null>(null),
    contactPersonAddress: new FormControl<string | null>(null),
    equipmentId: new FormControl<string | null>(null),
    vesselId: new FormControl<string | null>(null),
    equipmentCurrentStatus: new FormControl('', [Validators.required]),
    expectedPortCall: new FormControl<string | null>(null),
    extraDetails: new FormControl<string | null>(null),
    incidentDate: new FormControl<string | null>(null),
    incidentLeadup: new FormControl<string | null>(null),
    incidentPlace: new FormControl<string | null>(null),
    nextPort: new FormControl<string | null>(null),
    responseMeasures: new FormControl<string | null>(null),
    responseRequestDetails: new FormControl<string | null>(null),
    title: new FormControl('', [Validators.required]),
    isRead: new FormControl(0),
    isConfidential: new FormControl(0),
    tags: new FormControl<string[]>([]),
    csNumberSuffix: new FormControl(''),
    recordType: new FormControl('inquiry')
  })
}